var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Paypal_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Paypal_svg__st1{display:none}.Paypal_svg__st5{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#1334cb}")), /*#__PURE__*/React.createElement("path", {
    d: "M38 24H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h36c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 8h4.2c2.3 0 3.1 1.2 3 2.8-.2 2.8-1.9 4.3-4.2 4.3H21c-.3 0-.5.2-.6.8l-.5 3.2q0 .3-.3.3H17c-.3 0-.3-.2-.3-.6l1.6-10.3c.1-.3.3-.5.8-.5",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#009ee3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 4.5h4.3c1.2 0 2.6 0 3.6.9.6.6 1 1.4.9 2.4-.3 3.2-2.2 5-4.8 5h-2.1c-.4 0-.6.2-.7.9l-.6 3.7c0 .2-.1.4-.3.4H14c-.3 0-.4-.2-.3-.7l1.9-11.9c.1-.5.3-.7.8-.7",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#113984"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.6 13.3.7-4.7c.1-.4.3-.6.8-.6h4.2c.7 0 1.3.1 1.7.3-.4 2.9-2.3 4.5-4.7 4.5h-2.1c-.3 0-.5.2-.6.5",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#172c70"
    }
  }));
};
export default SvgPaypal;